"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.useInitialVariables = exports.InitialVariablesProvider = exports.InitialVariablesContext = void 0;

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _jsxRuntime = require("react/jsx-runtime");

// deps

/** @type {import("react").Context<any>} */
const InitialVariablesContext = /*#__PURE__*/(0, _react.createContext)(null);
exports.InitialVariablesContext = InitialVariablesContext;
const {
  Provider
} = InitialVariablesContext;

const _InitialVariablesProvider = function ({
  children,
  ...otherProps
}) {
  const initialVariables = (0, _react.useRef)(otherProps);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Provider, {
    value: initialVariables.current,
    ...otherProps,
    children: children
  });
};

_InitialVariablesProvider.displayName = "InitialVariablesProvider";
_InitialVariablesProvider.propTypes = {
  children: _propTypes.default.node
};
const InitialVariablesProvider = /*#__PURE__*/(0, _react.memo)(_InitialVariablesProvider);
exports.InitialVariablesProvider = InitialVariablesProvider;

const useInitialVariables = function () {
  return (0, _react.useContext)(InitialVariablesContext);
};

exports.useInitialVariables = useInitialVariables;